import { ReactNode } from "react";
import { BasicInfoForm } from "../components/BasicInfoForm";
import { ContactInfoForm } from "../components/ContactInfoForm";
import { OperationsForm } from "../components/OperationsForm";
import UpdateForm from "../components/UpdateForm";
import NotificationSettings from "../components/NotificationSettings";
import RoleManagement from "../components/RoleManagement";
import PermissionContent from "../components/PermissionsContent";
import Subscription from "../components/Subcription";

export interface Section {
  id: string;
  title: string;
  description?: string;
  content: ReactNode;
}

export interface SectionsByCategory {
  profile: Section[];
  security: Section[];
  notifications: Section[];
  roles: Section[];
  permission: Section[];
  subscription: Section[];
}

// helper to generate sections dynamically based on type
const createSections = (type: "company" | "individual"): SectionsByCategory => ({
  profile: [
    {
      id: "basic",
      title: "Basic Information",
      description: type === "company"
        ? "Your Company’s Core Information"
        : "Personal details you provide",
      content: <BasicInfoForm type={type} />,
    },
    {
      id: "contact",
      title: "Contact Information",
      description: type === "company"
        ? "How to connect with you"
        : "Ways to reach you",
      content: <ContactInfoForm type={type} />,
    },
    {
      id: "operations",
      title: "Operations",
      description: type === "company"
        ? "Business Hours & Service Coverage"
        : "Business Hours & Service Coverage",
      content: <OperationsForm type={type} />,
    },
  ],

  roles: [
    {
      id: "roles",
      title: type === "company" ? "Role Management" : "User & Role Management",
      description: "Control user roles.",
      content: <RoleManagement type={type} />,
    },
  ],

  permission: [
    {
      id: "permission",
      title: "Permission Management",
      description: "Control Permission Management.",
      content: <PermissionContent mode="config" />,

    },
  ],

  security: [
    {
      id: "password",
      title: "Update Password",
      description:
        "Keep your account secure by updating your password regularly.",
      content: <UpdateForm type={type} />,
    },
  ],

  notifications: [
    {
      id: "preferences",
      title: "Notification Preferences",
      description: "Choose how you’d like to receive alerts",
      content: <NotificationSettings />,
    },
  ],

  subscription: [
    {
      id: "plans",
      title: "Subscription Plan",
      description: "Manage your current subscription and billing info",
      content: <Subscription type={type} />,
    },
  ],
});

// now export both sets
export const companySections = createSections("company");
export const individualSections = createSections("individual");
